<template>
  <transition name="modal">
    <portal to="destination">
      <div class="modal-backdrop z-20" v-show="show" @click.self="$emit('close')">
        <div
          class="relative modal flex justify-center text-center flex-col -font-normal p-auto text-xm pt-8"
          v-if="remind_type==='remind'"
        >
          <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <p class>
            <span class="text-brand-light font-bold">{{userData.name}}</span>, мы напомним
          </p>
          <p class>вам о регистрации {{reminder.time.toLowerCase().replace(/\s/g, '')}} до её начала</p>
          <P>{{reminder.push.toLowerCase()}}.</P>
          <br />
          <div class="px-8">
            <p class="pt-4 font-bold">Хорошего дня!</p>
          </div>
        </div>
        <div
          class="relative modal flex justify-center text-center flex-col -font-normal p-auto text-xm pt-8"
          v-if="remind_type==='remind_deny'"
        >
          <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <p class>
            <span class="text-brand-light font-bold">{{userData.name}}</span>, вы отменили напоминание
          </p>
          <p class>о регистрации.</p>
          <br />
        </div>
      </div>
    </portal>
  </transition>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['remind_type', 'reminder'],
  name: 'reminder',
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
      return this.show === false;
    },
  },
  created() {
    document.body.style.overflow = 'hidden';
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },


  computed: {
    userData() {
      return this.$store.getters.userInfo;
    },
  },
};

</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 2rem;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal {

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .modal {
        width: 27rem;
        height: 13rem;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        background-color: #ffffff;
    }

</style>
